import { useQuery } from '@tanstack/react-query';
import { fetchReapproAlgorithmParams } from '../queries/reapproAlgorithms.queries';

export const useReapproAlgorithmParams = () => {
    return useQuery({
        queryKey: ['reapproAlgorithmParams'],
        queryFn: fetchReapproAlgorithmParams,
    });
};
